import { stocks } from "../../utils/stocks";

const EXCHANGES = ["NYSE", "NASDAQ", "COINBASE", "OANDA", "TVC"] as const;

/**
 * Turns dropdown selections ("AAPL - Apple Inc") into fully qualified
 * TradingView symbols ("NASDAQ:AAPL - Apple Inc"), skipping anything that does
 * not resolve on one of the supported exchanges.
 */
export function generateSymbolsFromSelections(selections: string[]): string[] {
  const symbols: string[] = [];
  selections.forEach(selection => {
    const symbol = selection.split(" ")[0];
    for (const exchange of EXCHANGES) {
      const name = stocks[`${exchange}:${symbol}`];
      if (name !== undefined) {
        symbols.push(`${exchange}:${symbol} - ${name}`);
        break;
      }
    }
  });
  return symbols;
}

// symbols have the format `NASDAQ:AAPL - Apple Corp`
export function createTradingViewSymbolMap<
  S extends string,
  D extends string
>(
  symbols: string[],
  symbolKey: S,
  descriptionKey: D
): Record<S | D, string>[] {
  return symbols.map(symbol => {
    const splitSymbols = symbol.split("-");
    return {
      [symbolKey]: splitSymbols[0].trim(),
      [descriptionKey]: `${splitSymbols[0].trim()} - ${splitSymbols[1].trim()}`
    } as Record<S | D, string>;
  });
}
